/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CriticalElementDto,
  GetClientCriticalElementsParams,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Any authenticated role**
 */
export const getClientCriticalElementById = (
  userId: string,
  clientId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalElementDto>(
    {
      url: `/api/${userId}/clients/${clientId}/critical-elements/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetClientCriticalElementByIdQueryKey = (
  userId: string,
  clientId: number,
  id: number
) => {
  return [
    `/api/${userId}/clients/${clientId}/critical-elements/${id}`,
  ] as const;
};

export const getGetClientCriticalElementByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientCriticalElementById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalElementById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientCriticalElementByIdQueryKey(userId, clientId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientCriticalElementById>>
  > = ({ signal }) =>
    getClientCriticalElementById(userId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientCriticalElementById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientCriticalElementByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientCriticalElementById>>
>;
export type GetClientCriticalElementByIdQueryError = ErrorType<unknown>;

export function useGetClientCriticalElementById<
  TData = Awaited<ReturnType<typeof getClientCriticalElementById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalElementById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCriticalElementById>>,
          TError,
          Awaited<ReturnType<typeof getClientCriticalElementById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalElementById<
  TData = Awaited<ReturnType<typeof getClientCriticalElementById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalElementById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCriticalElementById>>,
          TError,
          Awaited<ReturnType<typeof getClientCriticalElementById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalElementById<
  TData = Awaited<ReturnType<typeof getClientCriticalElementById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalElementById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientCriticalElementById<
  TData = Awaited<ReturnType<typeof getClientCriticalElementById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalElementById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientCriticalElementByIdQueryOptions(
    userId,
    clientId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const updateClientCriticalElement = (
  userId: string,
  clientId: number,
  id: number,
  criticalElementDto: BodyType<CriticalElementDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalElementDto>(
    {
      url: `/api/${userId}/clients/${clientId}/critical-elements/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: criticalElementDto,
      signal,
    },
    options
  );
};

export const getUpdateClientCriticalElementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClientCriticalElement>>,
    TError,
    {
      userId: string;
      clientId: number;
      id: number;
      data: BodyType<CriticalElementDto>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClientCriticalElement>>,
  TError,
  {
    userId: string;
    clientId: number;
    id: number;
    data: BodyType<CriticalElementDto>;
  },
  TContext
> => {
  const mutationKey = ['updateClientCriticalElement'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClientCriticalElement>>,
    {
      userId: string;
      clientId: number;
      id: number;
      data: BodyType<CriticalElementDto>;
    }
  > = (props) => {
    const { userId, clientId, id, data } = props ?? {};

    return updateClientCriticalElement(
      userId,
      clientId,
      id,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClientCriticalElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClientCriticalElement>>
>;
export type UpdateClientCriticalElementMutationBody =
  BodyType<CriticalElementDto>;
export type UpdateClientCriticalElementMutationError = ErrorType<unknown>;

export const useUpdateClientCriticalElement = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateClientCriticalElement>>,
      TError,
      {
        userId: string;
        clientId: number;
        id: number;
        data: BodyType<CriticalElementDto>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateClientCriticalElement>>,
  TError,
  {
    userId: string;
    clientId: number;
    id: number;
    data: BodyType<CriticalElementDto>;
  },
  TContext
> => {
  return useMutation(
    getUpdateClientCriticalElementMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const deleteClientCriticalElement = (
  userId: string,
  clientId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${userId}/clients/${clientId}/critical-elements/${id}`,
      method: 'DELETE',
      signal,
    },
    options
  );
};

export const getDeleteClientCriticalElementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClientCriticalElement>>,
    TError,
    { userId: string; clientId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClientCriticalElement>>,
  TError,
  { userId: string; clientId: number; id: number },
  TContext
> => {
  const mutationKey = ['deleteClientCriticalElement'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClientCriticalElement>>,
    { userId: string; clientId: number; id: number }
  > = (props) => {
    const { userId, clientId, id } = props ?? {};

    return deleteClientCriticalElement(userId, clientId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClientCriticalElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClientCriticalElement>>
>;

export type DeleteClientCriticalElementMutationError = ErrorType<unknown>;

export const useDeleteClientCriticalElement = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteClientCriticalElement>>,
      TError,
      { userId: string; clientId: number; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteClientCriticalElement>>,
  TError,
  { userId: string; clientId: number; id: number },
  TContext
> => {
  return useMutation(
    getDeleteClientCriticalElementMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Any authenticated role**
 */
export const getClientCriticalElements = (
  userId: string,
  clientId: number,
  params?: GetClientCriticalElementsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalElementDto[]>(
    {
      url: `/api/${userId}/clients/${clientId}/critical-elements`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetClientCriticalElementsQueryKey = (
  userId: string,
  clientId: number,
  params?: GetClientCriticalElementsParams
) => {
  return [
    `/api/${userId}/clients/${clientId}/critical-elements`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClientCriticalElementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalElements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientCriticalElementsQueryKey(userId, clientId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientCriticalElements>>
  > = ({ signal }) =>
    getClientCriticalElements(userId, clientId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientCriticalElements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientCriticalElementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientCriticalElements>>
>;
export type GetClientCriticalElementsQueryError = ErrorType<unknown>;

export function useGetClientCriticalElements<
  TData = Awaited<ReturnType<typeof getClientCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params: undefined | GetClientCriticalElementsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalElements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCriticalElements>>,
          TError,
          Awaited<ReturnType<typeof getClientCriticalElements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalElements<
  TData = Awaited<ReturnType<typeof getClientCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalElements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCriticalElements>>,
          TError,
          Awaited<ReturnType<typeof getClientCriticalElements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalElements<
  TData = Awaited<ReturnType<typeof getClientCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalElements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientCriticalElements<
  TData = Awaited<ReturnType<typeof getClientCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalElements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientCriticalElementsQueryOptions(
    userId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const createClientCriticalElement = (
  userId: string,
  clientId: number,
  criticalElementDto: BodyType<CriticalElementDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalElementDto>(
    {
      url: `/api/${userId}/clients/${clientId}/critical-elements`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: criticalElementDto,
      signal,
    },
    options
  );
};

export const getCreateClientCriticalElementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClientCriticalElement>>,
    TError,
    { userId: string; clientId: number; data: BodyType<CriticalElementDto> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClientCriticalElement>>,
  TError,
  { userId: string; clientId: number; data: BodyType<CriticalElementDto> },
  TContext
> => {
  const mutationKey = ['createClientCriticalElement'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClientCriticalElement>>,
    { userId: string; clientId: number; data: BodyType<CriticalElementDto> }
  > = (props) => {
    const { userId, clientId, data } = props ?? {};

    return createClientCriticalElement(userId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClientCriticalElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClientCriticalElement>>
>;
export type CreateClientCriticalElementMutationBody =
  BodyType<CriticalElementDto>;
export type CreateClientCriticalElementMutationError = ErrorType<unknown>;

export const useCreateClientCriticalElement = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createClientCriticalElement>>,
      TError,
      { userId: string; clientId: number; data: BodyType<CriticalElementDto> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createClientCriticalElement>>,
  TError,
  { userId: string; clientId: number; data: BodyType<CriticalElementDto> },
  TContext
> => {
  return useMutation(
    getCreateClientCriticalElementMutationOptions(options),
    queryClient
  );
};
